"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseXMLString = parseXMLString;
function parseXMLString(xmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlString, 'text/xml');
    // Check for parsing errors
    const errorNode = doc.querySelector('parsererror');
    if (errorNode) {
        throw new Error(`XML parsing failed: ${errorNode.textContent}`);
    }
    const markupElement = doc.querySelector('Markup');
    if (!markupElement) {
        throw new Error('Invalid markup XML: No Markup element found');
    }
    return {
        Header: parseHeader(doc),
        Topic: parseTopic(doc)
    };
}
function parseHeader(doc) {
    const headerElement = doc.querySelector('Header');
    if (!headerElement) {
        throw new Error('No Header element found');
    }
    const fileElements = headerElement.querySelectorAll('File');
    const files = Array.from(fileElements).map(fileEl => {
        var _a, _b;
        return ({
            IfcProject: fileEl.getAttribute('IfcProject') || '',
            Filename: ((_a = fileEl.querySelector('Filename')) === null || _a === void 0 ? void 0 : _a.textContent) || '',
            Date: ((_b = fileEl.querySelector('Date')) === null || _b === void 0 ? void 0 : _b.textContent) || ''
        });
    });
    return {
        Files: {
            File: files.length === 1 ? files[0] : files
        }
    };
}
function parseTopic(doc) {
    var _a, _b, _c, _d, _e, _f, _g;
    const topicElement = doc.querySelector('Topic');
    if (!topicElement) {
        throw new Error('No Topic element found');
    }
    const topic = {
        Guid: topicElement.getAttribute('Guid') || '',
        TopicType: topicElement.getAttribute('TopicType') || undefined,
        TopicStatus: topicElement.getAttribute('TopicStatus') || undefined,
        Title: ((_a = topicElement.querySelector('Title')) === null || _a === void 0 ? void 0 : _a.textContent) || '',
        Priority: ((_b = topicElement.querySelector('Priority')) === null || _b === void 0 ? void 0 : _b.textContent) || undefined,
        CreationDate: ((_c = topicElement.querySelector('CreationDate')) === null || _c === void 0 ? void 0 : _c.textContent) || '',
        CreationAuthor: ((_d = topicElement.querySelector('CreationAuthor')) === null || _d === void 0 ? void 0 : _d.textContent) || '',
        ModifiedDate: ((_e = topicElement.querySelector('ModifiedDate')) === null || _e === void 0 ? void 0 : _e.textContent) || undefined,
        ModifiedAuthor: ((_f = topicElement.querySelector('ModifiedAuthor')) === null || _f === void 0 ? void 0 : _f.textContent) || undefined,
        AssignedTo: ((_g = topicElement.querySelector('AssignedTo')) === null || _g === void 0 ? void 0 : _g.textContent) || undefined
    };
    // Parse Labels
    const labelsElement = topicElement.querySelector('Labels');
    if (labelsElement) {
        const labelElements = labelsElement.querySelectorAll('Label');
        topic.Labels = Array.from(labelElements).map(label => label.textContent || '');
    }
    // Parse Comments
    const commentsElement = topicElement.querySelector('Comments');
    if (commentsElement) {
        const commentElements = commentsElement.querySelectorAll('Comment');
        if (commentElements.length > 0) {
            const comments = Array.from(commentElements).map(commentEl => {
                var _a, _b, _c, _d, _e;
                return ({
                    Guid: commentEl.getAttribute('Guid') || '',
                    Date: ((_a = commentEl.querySelector('Date')) === null || _a === void 0 ? void 0 : _a.textContent) || '',
                    Author: ((_b = commentEl.querySelector('Author')) === null || _b === void 0 ? void 0 : _b.textContent) || '',
                    Comment: ((_c = commentEl.querySelector('Comment')) === null || _c === void 0 ? void 0 : _c.textContent) || '',
                    ModifiedDate: ((_d = commentEl.querySelector('ModifiedDate')) === null || _d === void 0 ? void 0 : _d.textContent) || undefined,
                    ModifiedAuthor: ((_e = commentEl.querySelector('ModifiedAuthor')) === null || _e === void 0 ? void 0 : _e.textContent) || undefined
                });
            });
            topic.Comments = {
                Comment: comments.length === 1 ? comments[0] : comments
            };
        }
    }
    // Parse Viewpoints
    const viewpointsElement = topicElement.querySelector('Viewpoints');
    if (viewpointsElement) {
        const viewpointElements = viewpointsElement.querySelectorAll('ViewPoint');
        if (viewpointElements.length > 0) {
            const viewpoints = Array.from(viewpointElements).map(vpEl => {
                var _a, _b;
                return ({
                    Guid: vpEl.getAttribute('Guid') || '',
                    Viewpoint: ((_a = vpEl.querySelector('Viewpoint')) === null || _a === void 0 ? void 0 : _a.textContent) || undefined,
                    Snapshot: ((_b = vpEl.querySelector('Snapshot')) === null || _b === void 0 ? void 0 : _b.textContent) || undefined
                });
            });
            topic.Viewpoints = {
                ViewPoint: viewpoints.length === 1 ? viewpoints[0] : viewpoints
            };
        }
    }
    return topic;
}
